import { Viewports as e } from "./index4.js";
const p = (x, i = ["xxl", "xl", "l", "m", "s", "xs"]) => {
  var s;
  const l = {
    xxl: e.XXL,
    xl: e.XL,
    l: e.L,
    m: e.M,
    s: e.S,
    xs: 0
  }, o = Object.entries(l).filter(([t]) => i.includes(t)).sort((t, r) => r[1] - t[1]);
  for (const [t, r] of o)
    if (x >= r)
      return t;
  return ((s = o.pop()) == null ? void 0 : s[0]) ?? "xxs";
};
export {
  p as getViewport
};
